import { Sigla } from '../Sigla'
import { Grid, Segment, Icon, Message, Popup, Button, Modal, Card } from 'semantic-ui-react'
import './style.less'
import { Link } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { useStore } from '../../stores/useStoreProfile'
import { usePautas } from '../../hooks/usePautas'
import { Pauta } from '../../hooks/types/pautasTypes'
import { Print } from '../Print'
import { v4 as uuidv4 } from 'uuid'
import TextEditor from '../TextEditor'
import { ModalPautaProps, PautaAreasType } from './types'

const ModalPauta = (props: ModalPautaProps) => {
  const [open, setOpen] = useState(false)
  const { trigger, pauta } = props

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={trigger}
    >
      <Modal.Header>{pauta.titulo}</Modal.Header>
      <Modal.Content>
        <TextEditor
          disabled
          value={pauta.descricao}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>
          Fechar
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

const PautasArea = ({ area, onExcluir }: {
  area: PautaAreasType,
  onExcluir: (id: number) => Promise<void>
}) => {
  const { store } = useStore()
  const { change_pauta, delete_pauta } = store.permissions

  const canEditar = (pauta: Pauta) => {
    return change_pauta.find((e: any) =>
      (e.departamento === pauta.departamento?.toString()) &&
      (e.area_relatora === pauta.area_relatora?.toString())
    )
  }

  const canExcluir = (pauta: Pauta) => {
    return delete_pauta.find((e: any) =>
      (e.departamento === pauta.departamento?.toString()) &&
      (e.area_relatora === pauta.area_relatora?.toString())
    )
  }


  const RowPauta = ({ pauta }: { pauta: Pauta }) => {
    const [showPopup, setShowPopup] = useState(false)

    return <Grid.Row columns='equal'>
      {canEditar(pauta) && pauta.publicada &&
        <Grid.Column width={1} textAlign='center' verticalAlign='middle'>
          <Icon color='green' name='certificate' title='Publicada' />
        </Grid.Column>
      }
      <Grid.Column verticalAlign='middle'>
        <Segment basic title={pauta.titulo}>{pauta.titulo}</Segment>
      </Grid.Column>
      <Grid.Column width={1} textAlign='center' verticalAlign='middle'>
        <ModalPauta
          pauta={pauta}
          trigger={<a href='#/'><Icon title="Visualizar Destaque" name='eye' /></a>}
        />
        {canEditar(pauta) &&
          <Link name="link-editpauta" to={`/destaque/editar/${pauta.id}`}>
            <Icon title="Editar Destaque" name='pencil' />
          </Link>}

        {canExcluir(pauta) && <Popup
          name="btn-exclui-pauta"
          title="Excluir"
          trigger={<Icon title="Excluir Destaque" className='button-excluir' name='trash alternate' />}
          on='click'
          onOpen={() => setShowPopup(true)}
          onClose={() => setShowPopup(false)}
          open={showPopup}
        >
          <Popup.Header>Deseja excluir?</Popup.Header>
          <Popup.Content>
            <Button name="btn-cancela-excluir-pauta" onClick={() => setShowPopup(false)}>Não</Button>
            <Button name="btn-confirm-excluir-pauta" onClick={() => pauta.id && onExcluir(pauta.id)}>Sim</Button>
          </Popup.Content>
        </Popup>
        }
      </Grid.Column>
    </Grid.Row>
  }


  return <Segment basic className='pautas-area' title={area.sigla}>
    <Sigla key={1} size={5}>
      {area.sigla}
    </Sigla>
    <Grid divided='vertically'>
      {area.pautas?.map(e =>
        <RowPauta key={e.id} pauta={e} />
      )}
    </Grid>
  </Segment>
}

const CardPautas = ({ setError }: { setError: (e: string | undefined) => void }) => {
  const { pautas, api } = usePautas()
  const updateInterval = 20 // Intervalo em segundos
  const timeoutRef = useRef(setTimeout(() => 0))

  const { store } = useStore()
  const { view_pauta } = store.permissions

  const canViewPauta = Boolean(view_pauta.filter((e: any) => e.area_relatora || e.departamento).length)

  useEffect(() => {
    const list = async () => {
      try {
        await api.list()
        const timeout = setTimeout(() => list(), updateInterval * 1000)
        if (timeout) timeoutRef.current = timeout
      } catch (error) {
        setError(error);
      }
    }

    if (canViewPauta) {
      list()
    }
    return () => clearTimeout(timeoutRef.current)
  }, [])  // eslint-disable-line


  const pautasArea = pautas.reduce<PautaAreasType[]>((a, c) => {
    const dep = a.find(e => e.id === c.area_relatora)
    if (dep) {
      dep.pautas?.push(c)
    } else {
      a.push({
        id: c.area_relatora,
        sigla: c.sigla_area_relatora,
        pautas: [c]
      })
    }
    return a
  }, [])

  const onExcluir = async (id: number) => {
    await api.excluir(id)
    await api.list()
  }

  return (
    <Card fluid className={'card_pautas'}>
      <Card.Content>
        <Card.Header>
          <div style={{ display: 'flex', width: '100%' }}>
            <h1>Destaques do dia</h1>
            <div className='circle' >
              <Print setError={setError} title="Exportar como documento do Word" name='btn-imprimir' extensao='docx' template='pauta' id={null} disabled={false} />
            </div>
          </div>
        </Card.Header>
        <Card.Description>
          {pautasArea.length
            ? pautasArea.map(e =>
              <PautasArea
                key={uuidv4()}
                area={e}
                onExcluir={onExcluir}
              />
            )
            : <Message size='mini' compact icon='inbox' header='Não há dados' />
          }
        </Card.Description>
      </Card.Content>
    </Card>
  )
}

export default CardPautas
